<div class="column-picker-item">
  <mat-menu #childMenu="matMenu" [overlapTrigger]="false" class="column-picker-item__menu">
    @for (child of items; track child.key) {
      @if (child.children && child.children.length > 0) {
        <button
          mat-menu-item
          [matMenuTriggerFor]="menu.childMenu"
          #trigger="matMenuTrigger"
          (mouseenter)="trigger.openMenu()">
          <div class="column-picker-item__menu--button">
            <span class="material-symbols-outlined">folder</span>
            <span>{{ child.name | uppercase }}</span>
          </div>
        </button>
        <app-column-picker-item
          (selectedColumnKey)="selectedColumnKey.emit($event)"
          #menu
          [items]="child.children"></app-column-picker-item>
      }
      @if (!child.children || child.children.length === 0) {
        <button (click)="selectedColumnKey.emit(child)" mat-menu-item [disabled]="child.disabled">
          <div class="column-picker-item__menu--button">
            <span class="material-symbols-outlined">add_circle</span>
            <span>{{ child.name | uppercase }}</span>
          </div>
        </button>
      }
    }
  </mat-menu>
</div>
